export const staticConfig = {
    apiBaseUrl: (process.env.REACT_APP_API_URL as string),
    appBaseUrl: window.location.protocol + '//' + window.location.host + '/',
    defaultTitle: 'WADE',
    defaultUrl: '#root',
}